import { Tabs, } from "antd";
import React, { useState, useRef, useEffect } from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import "./InsuranceVPH.scss";
import moment from "moment";
import commonFn from "@/utils/commonFn";
import PropDetailModal from "./PropDetailModal";
import PolicyNumber from "@/views/AccountPayable/ApprovalSummary/component/PolicyNumber";
import RemarkPopover from "@/views/AccountPayable/ApprovalSummary/component/RemarkPopover";
export default function InsuranceVPH({ record }) {
  const [VPHprop, setVPHProp] = useState("");
  const [VPHList, setVPHList] = useState([]);
  const [tabsKey, setTabsKey] = useState("1");
  const [loading, setLoading] = useState(false);
  const propDetailModalRef = useRef(null);
  const [VPHGLAcct, setVPHGLAcct] = useState([]);
  const propId = record?.propId;

  // 选中的 Property 变化：重置并重新请求
  useEffect(() => {
    setTabsKey("1");
    setVPHProp("");
    setVPHList([]);
    setVPHGLAcct([]);
    if (!propId) return;

    let cancelled = false; // 快速切换时丢弃过期响应
    (async () => {
      setLoading(true);
      try {
        const response = await http.get(api.getInsuranceByPropAmount, {
          params: { propId },
        });
        if (cancelled) return;
        if (response?.code === "1") {
          setVPHProp(response.data?.prop || "");
          setVPHList(response.data?.yearGroups || []);
          setVPHGLAcct(response.data?.pendingInsuranceGlAcctGroups || []);
        }
      } catch (error) {
        console.error("接口调用失败:", error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [propId]);
  // 切到 Unit Information 时加载单元详情
  useEffect(() => {
    if (tabsKey === "2" && propId) {
      propDetailModalRef.current?.openModal({
        modalName: "View Property Detail",
        propId,
        isModal: false,
      });
    }
  }, [tabsKey, propId]);

  const renderCards = (list = [], isYear = true) =>
    list.map((item, index) => {
      const showAvg = isYear
        ? item?.showYearAverage
        : item?.showCurrentYearWithPendingAverage;
      const avg = isYear
        ? item.yearAverage
        : item.currentYearWithPendingAverage;

      return (
        <div className="ins-panel__year" key={index}>
          <div className="ins-panel__year-head">
            <div className="ins-panel__year-name">
              {commonFn.iconDocFn({
                iconKey: "ASIDYear",
                width: 24,
                height: 24,
                marginRight: 4,
              })}
              {isYear ? (
                item.year
              ) : (
                <div>
                  <div>Pending</div>
                  <div className="ins-panel__year-amount-value">
                    {commonFn.amountToDollarFn(
                      item.currentYearWithPendingTotal,
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="ins-panel__year-amount">
              <div className="ins-panel__year-amount-label">
                {isYear ? "Total amount" : "Total"}
              </div>
              <div className="ins-panel__year-amount-value ins-panel__year-amount-value--lg">
                {commonFn.amountToDollarFn(item.yearTotal)}
              </div>
              {showAvg && (
                <>
                  <div className="ins-panel__year-amount-label">Per Unit</div>
                  <div className="ins-panel__year-amount-value">
                    {commonFn.amountToDollarFn(avg)}
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="ins-panel__gl-list">
            {item?.glAcctGroups?.length ? (
              item.glAcctGroups.map((value, idx) => (
                <div className="ins-panel__gl" key={idx}>
                  <div className="ins-panel__gl-head">
                    {commonFn.iconDocFn({
                      iconKey: "ASIDGlacct",
                      width: 20,
                      height: 20,
                      marginRight: 4,
                    })}
                    <span className="ins-panel__gl-name">{value.glAcct}</span>
                    <span className="ins-panel__gl-amount">
                      {commonFn.amountToDollarFn(value.yearGlTotal)}
                    </span>
                  </div>
                  {value?.batches?.length ? (
                    <div className="ins-panel__batches">
                      {value.batches.map((v, batchIdx) => (
                        <div className="ins-panel__batch" key={batchIdx}>
                            <RemarkPopover propRecord={v}>
                          <span>
                            {moment([
                              v.pushTime[0],
                              v.pushTime[1] - 1,
                              v.pushTime[2],
                            ]).format("MM/DD/YYYY")}
                          </span>
                          </RemarkPopover>
                          {/* <span>{v.number}</span> */}
                       <PolicyNumber propRecord={record} v={v} />
                        <RemarkPopover propRecord={v}>
                          <span>{commonFn.amountToDollarFn(v.amount)}</span>
                          </RemarkPopover>
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              ))
            ) : (
              <div className="ins-panel__gl-no-data">No Data</div>
            )}
          </div>
        </div>
      );
    });

  const amountDoc = (
    <>
      <div className="ins-panel__list">
        {loading ? (
          <div className="ins-panel__loading">Loading...</div>
        ) : VPHList.length > 0 ? (
          renderCards(VPHList, true)
        ) : (
          <div className="ins-panel__no-data">No payment history data</div>
        )}
      </div>

      <div className="ins-panel__section">
        <div className="ins-panel__section-title">Pending Submission</div>
        <div className="ins-panel__list">
          {VPHGLAcct.length > 0 ? (
            renderCards(VPHGLAcct, false)
          ) : (
            <div className="ins-panel__no-data">No pending submission</div>
          )}
        </div>
      </div>
    </>
  );
  const unitDoc = (
    <PropDetailModal
      ref={propDetailModalRef}
      detailUrl={api.ASInsurancePropDetails}
      tableUrl={api.ASInsuranceUnitDetails}
    />
  );

  if (!propId) {
    return (
      <div className="ins-panel ins-panel--empty">
        Select a property on the left to view details
      </div>
    );
  }

  return (
    <div className="ins-panel">
      <div className="ins-panel__title">Prop：{VPHprop}</div>
      <Tabs
        activeKey={tabsKey}
        onChange={setTabsKey}
        items={[
          {
            key: "1",
            label: "Payment History",
            forceRender: true,
            children: amountDoc,
          },
          {
            key: "2",
            label: "Unit Information",
            forceRender: true,
            children: unitDoc,
          },
        ]}
      />
    </div>
  );
}
